import React from 'react';
import { NavLink, Redirect, Route } from 'react-router-dom';
import { Container, Menu } from 'semantic-ui-react';

import { BuscarApoderado, DeudoresCuotas, FichaDeApoderado, Gastos, Informes } from './componentes';
import GastosNotarialesYAbonos from './componentes/Deudores/componentes/DeudoresCobrosCalculados/GastosNotarialesYAbonos';
import MenuDeudores from './componentes/Deudores/MenuDeudores';
import Nulos from './componentes/Nulos';
import RecordatoriosDePago from './componentes/RecordatoriosDePago';

const CobranzasPrincipal: React.FunctionComponent = () => {
    return (
        <Container>
            <Menu pointing secondary>
                <Menu.Item as={NavLink} exact to='/cobranzas/buscar' content='Buscar' />
                <Menu.Item as={NavLink} to='/cobranzas/deudores' content='Deudores' />
                <Menu.Item as={NavLink} to='/cobranzas/gastos' content='Gastos' />
                <Menu.Item as={NavLink} to='/cobranzas/informes' content='Informes' />
                <Menu.Item as={NavLink} to='/cobranzas/nulos' content='Nulos' />
                <Menu.Item as={NavLink} to='/cobranzas/dias-de-pago' content='Días de pago' />
            </Menu>

            <Route exact path='/cobranzas' render={() => <Redirect to='/cobranzas/buscar' />} />
            <Route
                exact
                path='/cobranzas/buscar'
                children={({ match }) => <BuscarApoderado ocultar={!match} />}
            />

            <Route path='/cobranzas/deudores' component={MenuDeudores} />

            <Route
                exact
                path='/cobranzas/deudores'
                render={() => <Redirect to={'/cobranzas/deudores/cuotas'} />}
            />
            <Route
                path='/cobranzas/deudores/cuotas'
                children={({ match }) => <DeudoresCuotas ocultar={!match} />}
            />
            <Route
                path='/cobranzas/deudores/otros-cobros'
                children={({ match }) => <GastosNotarialesYAbonos ocultar={!match} />}
            />

            <Route path='/cobranzas/plan/:id' component={FichaDeApoderado} />
            <Route exact path='/cobranzas/gastos' component={Gastos} />
            <Route exact path='/cobranzas/informes' component={Informes} />

            <Route exact path='/cobranzas/nulos' component={Nulos} />
            <Route
                path='/cobranzas/dias-de-pago'
                children={({ match }) => <RecordatoriosDePago ocultar={!match} />}
            />
        </Container>
    );
};

export default CobranzasPrincipal;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/CobranzasPrincipal.tsx